import ServiceDetailLayout from '../components/ServiceDetailLayout';
import { serviceDetails } from '@/mocks/service-details';

export default function InteriorWorksPage() {
  return <ServiceDetailLayout data={serviceDetails['interior-works']} />;
}